<template>
  <div class="block-l">
    <div class="block-l__content">
      <div class="block-l__left">
        <div class="block-l__head" data-aos="fade-up">
          <div class="block-l__title"><strong>&</strong></div>
          <div class="block-l__title block-l__title--2">Любовь <br>ладан</div>
        </div>
        <div class="block-l__right mobile">
          <div class="block-l__row" data-aos="fade-up">
            <div class="block-l__image block-l__image--1">
              <img src="../assets/img/block-l-1.jpg" alt="">
            </div>
            <div class="block-l__row" data-aos="fade-up">
              <div class="block-l__image block-l__image--3">
                <img src="../assets/img/block-l-3-m.png" alt="">
              </div>
            </div>
            <div class="block-l__letter letter letter-line">
              Л.
            </div>
          </div>
        </div>
        <div class="block-l__text text text-white" data-aos="fade-up">
          <p>Именно Вертинскому была обязана своим стремительным взлётом Вера Холодная. Познакомившись с Верой по возвращении с фронта и разглядев в ней доселе никем <br>не замеченную «демоническую красоту», Вертинский привёл её на кинофабрику Ханжонкова, что и сделало впоследствии её одной из самых известных актрис русского немого кино.</p>
          <p>Ей Вертинский посвятил несколько из своих первых песен — в том числе «Ваши пальцы пахнут ладаном». Похоронные мотивы песни встревожили актрису — <br>и она попросила снять посвящение, что Вертинский <br>и сделал. Но рок судьбы был неумолим, по чудовищному совпадению песня оказалась пророческой: через три года Вера умерла.</p>
        </div>
      </div>
      <div class="block-l__right desktop">
        <div class="block-l__row" data-aos="fade-up">
          <div class="block-l__letter letter letter-line">
            Л.
          </div>
          <div class="block-l__image block-l__image--1">
            <img src="../assets/img/block-l-1.jpg" alt="">
          </div>
        </div>
        <div class="block-l__row" data-aos="fade-up">
          <div class="block-l__image block-l__image--2">
            <img src="../assets/img/block-l-2.jpg" alt="">
          </div>
          <div class="block-l__image block-l__image--3">
            <img src="../assets/img/block-l-3.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockG'
}
</script>

<style lang="sass">
  .block-l
    @media screen and (max-width: 999px)
      padding-bottom: vwm(138px)
    &__content
      display: flex
      position: relative
      z-index: 10
      @media screen and (max-width: 999px)
        flex-direction: column
    &__text
      @media screen and (max-width: 999px)
        margin-left: vwm(18px)
        margin-top: vwm(68px)
        width: 90vw
        br
          display: none
        p
          margin-bottom: vwm(27px)
    &__left
      width: 50%
      min-width: 50%
      padding-left: vw(199px)
      padding-top: vw(20px)
      @media screen and (max-width: 999px)
        width: 100%
        min-width: 100%
        padding-left: 0
        padding-top: vwm(20px)
    &__right
      width: 50%
      min-width: 50%
      margin-left: vw(34px)
      @media screen and (max-width: 999px)
        width: 100%
        min-width: 100%
    &__letter
      padding-left: vw(26px)
      padding-top: vw(13px)
      @media screen and (max-width: 999px)
        margin-top: vwm(-293px)
        margin-left: vwm(16px)
        padding-left: vwm(14px)
    &__row
      display: flex
      @media screen and (max-width: 999px)
        flex-direction: column
    &__image
      img
        width: 100%
      &--1
        width: vw(496px)
        margin-left: vw(-145px)
        @media screen and (max-width: 999px)
          width: vwm(356px)
          margin-left: vwm(-9px)
      &--2
        width: vw(285px)
        margin-left: vw(-13px)
        margin-top: vw(13px)
        position: relative
        &:after
          content: ''
          width: vw(189px)
          height: vw(269px)
          position: absolute
          background-image: url(../assets/img/block-l-el.png)
          background-size: contain
          background-repeat: no-repeat
          right: vw(-45px)
          top: vw(-36px)
      &--3
        width: vw(365px)
        margin-top: vw(-81px)
        margin-left: vw(11px)
        margin-bottom: vw(-4px)
        @media screen and (max-width: 999px)
          width: vwm(180px)
          margin-left: vwm(186px)
          margin-top: vwm(-125px)
    &__head
      display: flex
      padding-left: vw(3px)
      margin-bottom: vw(35px)
      @media screen and (max-width: 999px)
        padding-left: vwm(15px)
        padding-top: vwm(27px)
    &__title
      font-size: vw(72px)
      font-family: 'ZnikomitNo25'
      color: #fff
      @media screen and (max-width: 999px)
        font-size: vwm(57px)
      strong
        font-size: vw(200px)
        color: #E1C99C
        font-weight: 100
        @media screen and (max-width: 999px)
          font-size: vwm(158px)
      &--2
        padding-top: vw(27px)
        line-height: vw(80px)
        padding-left: vw(19px)
        @media screen and (max-width: 999px)
          line-height: vwm(63px)
          padding-left: vwm(18px)
          padding-top: vwm(22px)
</style>
